import React from 'react';
import IconType from './iconType';

function XIcon({ width = 24, height = 24, color = '#616161', ...rest }: IconType) {
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.46875 15.5456L15.5398 8.47461" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8.46875 8.47461L15.5398 15.5456" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export default XIcon;
